import { FC } from "react";
import { Stack } from "@mui/material";
import { CommitmentUtilizationWidgetHighChart } from "./CommitmentUtilizationWidgetHighChart";
import { useAppSelector } from "@/store/hooks";
import { commitmentUtilizationWidgetByWidgetIdDataSelector } from "@/store/dashboards/selectors/widgets/commitment-utilization/widget-view/commitmentUtilizationWidgetByWidgetIdDataSelector";
import { commitmentUtilizationWidgetHasAggregationSelector } from "@/store/dashboards/selectors/widgets/commitment-utilization/widget-view/commitmentUtilizationWidgetHasAggregationSelector";
import { commitmentUtilizationWidgetVisualizationSelector } from "@/store/dashboards/selectors/widgets/commitment-utilization/widget-view/commitmentUtilizationWidgetVisualizationSelector";

interface CommitmentUtilizationWidgetChartViewProps {
  widgetId: string;
}

export const CommitmentUtilizationWidgetChartView: FC<
  CommitmentUtilizationWidgetChartViewProps
> = ({ widgetId }) => {
  const data = useAppSelector((state) =>
    commitmentUtilizationWidgetByWidgetIdDataSelector(state, widgetId),
  );
  const { groups } = data ?? {};

  const visualization = useAppSelector((state) =>
    commitmentUtilizationWidgetVisualizationSelector(state, widgetId),
  );
  const hasAggregations = useAppSelector((state) =>
    commitmentUtilizationWidgetHasAggregationSelector(state, widgetId),
  );

  if (!visualization) {
    return;
  }

  return (
    <Stack flex={1} p={2} justifyContent={hasAggregations ? "start" : "center"}>
      <CommitmentUtilizationWidgetHighChart
        data={groups}
        visualization={visualization}
        hasAggregations={hasAggregations}
      />
    </Stack>
  );
};
